<template>
  <div class="noverflow-sm">


        <div class="lead">
          <form v-if="settings.forms.showing_form_landing === true">
            <div class="form-group input-group home_form">

            <div id="landing_form" style="max-width: 600px; margin: 0 auto;">&nbsp;</div>

              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                    placeholder="Votre adresse email pro"
                    :value="profile.email"
                    @input="updateEmail($event)">

              <div class="d-inline-block over text-center">
                <a class="btn btn-lg btn-secondary submit_button" @click="saveEmailContinue" :class="{disabled: !isValid}" :aria-disabled="isValid">
                <!-- <a class="btn btn-lg btn-secondary" @click="saveEmailContinue"> -->
                  {{$t('front_end.start')}}
                </a>

              </div>
              <div class="w-100"></div>
              <div style="display: block;">
                <div class="alert alert-warning emailWrong" role="alert" v-if="wrongEmail">{{$t('front_end.email_wrong')}}</div>
                <small id="emailHelp" class="form-text text-muted">{{$t('front_end.email_needed')}} <i class="fa fa-spinner fa-spin" v-if="loading"></i></small>
              </div>
            </div>

          </form>

          <div class=" home_form_empty  mb-5"  v-if="settings.forms.showing_form_landing !== true">
            <div class=""  >
              <a class="btn btn-lg btn-secondary submit_button" @click="fetchSurveyContinue" >
              <!-- <a class="btn btn-lg btn-secondary" @click="saveEmailContinue"> -->
                {{$t('front_end.start')}} &nbsp; <i class="fa fa-forward"></i>
              </a>

            </div>
          </div>

        </div>

  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex';


  import {
    UPDATE_PROFILE
  } from '@/store/lead/mutations';

  export default {
    name: 'survey-start',

    data() {
      return {
        loading: false,
        isValid: false,
        shouldCheckEmailValidity: false, // for the moment we don't check email existence
        wrongEmail: false
      }
    },

    created() {
      this.getQuizList();
      this.checkEmail();
    },

    mounted(){

      // Displaying the landing page Hubspot form
      if (this.settings.forms.showing_form_landing === true) {
        hbspt.forms.create({
          portalId: "5878745",
          formId: "1c54bd00-ccf8-4c13-9058-e76f6638e67f",
          target: '#landing_form',
        });


        // On Hubspot form submit, let's proceed to questions
        window.addEventListener('message', event => {
           if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
               this.submit_form_hubspot();
             }
           })
      }
    },

    computed: {
      ...mapGetters(
        {
          profile: 'lead/profile',
          docID: 'lead/docID',
          survey: 'survey/survey',
          surveyID: 'survey/docID',
          quizList: 'quiz/list',
          settings: 'settings/settings',
        }
      )
    },

    methods: {
      ...mapMutations({
        updateProfile: 'lead/UPDATE_PROFILE',
        resetSurveyID: 'survey/RESET_SURVEY_ID',
      }),

      ...mapActions(
      {
        createLead: 'lead/getOrCreateProfile',
        createSurvey: 'survey/getOrCreateSurvey',
        getQuizList: 'quiz/list'
      }),

      submit_form_hubspot(){
        console.log("HUBSPOT form submitted, we should go next")
      },

      updateEmail(event) {
        this.wrongEmail = false;
        var updatedProfile = this.profile;
        updatedProfile.email = event.target.value;
        this.updateProfile(updatedProfile);
        // We check the email to enable the submit button
        this.checkEmail();
      },

      validateEmail(email) {
        // Validate email address with regexp
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
      },

      async checkEmail() {
        // We're using NeverBounce for validation, so we attach to their event
        // console.log(event.target.validity.valid);
        // console.log(event);

        const email = this.profile.email

        if (!this.shouldCheckEmailValidity) {
          this.isValid = this.validateEmail(email);
        }
        else
        {
          // Else we use Neverbounce to check for email existence
          if (this.validateEmail(email)) {
            console.log("Validated email : ", email);
            var currentComponent = this;
            currentComponent.loading = true;
            // If the syntax is correct we hit Neverbounce API to see if email is correct
            _nb.api.getValidatePublic(email,
                function(result) {
                    console.log("Email sent and returned from NB: ", email);
                    // Returns a Result object
                    if (result.response.result!="invalid"){
                      currentComponent.isValid = true;
                      currentComponent.wrongEmail = false;
                    } else {
                      currentComponent.wrongEmail = true;
                    }
                    currentComponent.loading = false;
                },
                function(err) {
                    // Returns error message as string
                    console.log(err);
                    currentComponent.loading = false;
                }

            )
          }
        }


      },

      async fetchSurveyContinue() {
        // In this first version, we don't ask for email address on first page
        // and don't save the lead in DB
        // We just create a new survey and redirect to first page

        this.loading = true;

        // We reset the survey docID (because it is probably from another user)
        this.resetSurveyID();
        // We save the current survey session
        await this.createSurvey({"email": null, "quizList": this.quizList, "createWithoutEmail": true});

        // Get locale for relevant routing
        const locale = this.$i18n.locale;

        this.$router.push({ name: 'Survey questions', params: { lang: locale, pageNumber: '1' }});

        this.loading = false;
      },

      async saveEmailContinue(event) {
        // Save the email
        // Create a new survey
        // Redirect to first page
        this.loading = true;

        try {
          var created = await this.createLead();

          // If the lead is new, we reset the survey docID (because it is probably from another user)
          if (created) {
            this.resetSurveyID();
          }
          // Here we get the new lead profile, and we decide where we redirect him
          // If activeSurvey.status == started we redirect to survey page
          // If activeSurvey.status == missing_info we redirect to additionnal_info page
          // If activeSurvey.status == finished we redirect to results page
          await this.createSurvey({"email": this.profile.email, "quizList": this.quizList});

          // Get locale for relevant routing
          const locale = this.$i18n.locale;

          if (this.survey.status == "started") {
            this.$router.push({ name: 'Survey questions', params: { lang: locale, pageNumber: '1' }});
          }
          else if (this.survey.status == "missing_info") {
            this.$router.push({ name: 'Additional Information'});
          }
          else if (this.survey.status == "finished") {
            this.$router.push({ name: 'Additional Information'});
          }
          else {
            this.$router.push({ name: 'Additional Information'}); // we show the survey by default
          }
          // this.$router.push('/vos_informations');
        } catch(error) {
          console.log(error);
          alert('Something went wrong');
        }
        this.loading = false;

      },


    }
  }
</script>


<style scoped>

.home_form {
  width: calc(50vw - 40px);
  overflow-x: hidden;
}

.home_form_empty {
  /*width: calc(50vw - 40px);*/
  overflow-x: hidden;
}


.submit_button {
  border-top-right-radius: 60px!important;
  border-bottom-right-radius: 60px!important;
  z-index: 99;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  transform: translateX(-100%);
  line-height: 20px;
}


.home_form_empty .submit_button {
  border-radius: 60px!important;
  z-index: 99;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  transform: translateX(0%);
  line-height: 20px;
  padding: 25px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 1em;
}

.input-group > .form-control {
  z-index: 5;
  overflow-x: hidden;
}



.lead .over {
  z-index: 99;
  width: 1px;
}

#exampleInputEmail1 {
  padding-right: 174px;
}





.submit_button.disabled, .submit_button:disabled{
  opacity: 1;
  background-color: #6c757d!important;
  border-color: #6c757d!important;
}


.form-control {
  border-radius: 60px!important;
  border-top-right-radius: 60px!important;
  border-bottom-right-radius: 60px!important;
}

.emailWrong {
  margin: 15px 0 5px;
}

#emailError {
  margin: 15px 0 5px;
  padding: 5px;
  border: 1px #F55 solid;
  background: #EEE;
}

@media only screen and (max-width: 992px) {

  .submit_button {
    font-size: 15px;
  }

  #exampleInputEmail1 {
    padding-right: 138px;
  }
}

@media only screen and (max-width: 768px) {

  .submit_button {
    font-size: 12px;
  }

  #exampleInputEmail1 {
    padding-right:120px;
  }

  .home_form {
    overflow-x: hidden;
    width: calc(100vw - 100px);
  }

  .noverflow-sm {
    overflow-x: hidden;
  }

  .emailWrong {
    font-size: 12px;
  }
}

@media only screen and (max-width: 480px) {

  .submit_button {
    font-size: 12px;
  }

  #exampleInputEmail1 {
    padding-right: 120px;
  }

  .home_form {
    overflow-x: hidden;
    width: calc(100vw - 80px);
  }

  .noverflow-sm {
    overflow-x: hidden;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue